import { objectHookToContext } from '~/common/hookToContext'
import { StackProps } from '../../../chakra'

type SplitListContextValue = null | {
  index?: number
  onChange?: (index: number) => void
  isMobile: boolean
  // Whether the mobile drawer is open, only valid on mobile
  drawerIsOpen: boolean
  setDrawerIsOpen?: (isOpen: boolean) => void
}

// Simple Context to forward the index and onChange to the descendants
// as well as manage the mobile drawer state
export const [SplitListContext, useSplitListContext] = objectHookToContext<SplitListContextValue>()

export type SplitListProps = Omit<StackProps, 'onChange'> &
  Omit<Exclude<SplitListContextValue, null>, 'isMobile' | 'drawerIsOpen' | 'setDrawerIsOpen'>
